export default "__VITE_ASSET__CPCEBSJq__"